import { not } from 'ramda';
import { AText, Box } from '@alf/uikit';
import { useDeviceStore } from '@namespace/device';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';
import { notificationCenterActions } from '../../store';

import styles from './index.module.css';

const { SET_IS_NOTIFICATIONS_LIST_OPENED } = notificationCenterActions;

export const NotificationListHeader = () => {
  const { t } = useI18n();
  const { isMobile } = useDeviceStore();

  return (
    <Box className={styles.root} align="center" gap="s">
      {isMobile && (
        <Box onClick={() => SET_IS_NOTIFICATIONS_LIST_OPENED(not)}>
          <Icon name="icons/general/nav/back" size="s" color="txt_color_1" />
        </Box>
      )}
      <AText
        breed="BU"
        size={isMobile ? 'xl' : 'm'}
        color={isMobile ? 'txt_color_1' : 'txt_color_4'}
      >
        {t('web.notifications.header')}
      </AText>
    </Box>
  );
};
